import React from "react";
import logo from "@/assets/logo-andil.jpg";

// ANDIL brand logo (uploaded asset). Rendered with object-contain to preserve aspect ratio.
export function LogoMark({ size = 40, className = "", rounded = "rounded-xl" }) {
  return (
    <img
      src={logo}
      alt="ANDIL"
      className={`object-contain ${rounded} shrink-0 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
